import { render, staticRenderFns } from "./SearchSideBar.vue?vue&type=template&id=3870d9d7&scoped=true"
import script from "./SearchSideBar.vue?vue&type=script&lang=ts"
export * from "./SearchSideBar.vue?vue&type=script&lang=ts"
import style0 from "./SearchSideBar.vue?vue&type=style&index=0&id=3870d9d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870d9d7",
  null
  
)

export default component.exports